// exports CommentProjectDTOCode - an immutable object 'enum'
// usage: import { CommentProjectDTOCode } from '../../enums/CommentProjectDTOCode';
const commentProjectDTOCode = {
    NotAddedToXref: 1,
    AddedNoDeactivationDate: 2,
    AddedDeactivationDateInFuture: 3,
    AddedDeactivationDateInPast: 4
};
Object.freeze(commentProjectDTOCode);
export const CommentProjectDTOCode = commentProjectDTOCode;